import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Toggle03Right = function Toggle03Right(props) {
  return /*#__PURE__*/_jsxs("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: [/*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M2 12c0-3.3137 2.6863-6 6-6h8c3.3137 0 6 2.6863 6 6s-2.6863 6-6 6H8c-3.3137 0-6-2.6863-6-6"
    }), /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M16 14.5c1.3807 0 2.5-1.1193 2.5-2.5S17.3807 9.5 16 9.5s-2.5 1.1193-2.5 2.5 1.1193 2.5 2.5 2.5"
    })]
  }));
};
export default Toggle03Right;